import React, { Fragment } from "react";
import Container from "src/layout/Container";
import { Grid, Paper, Tab, Tabs, Box } from "@material-ui/core";
import TabPanel from "src/utils/TabPanel";
import LaboratoryTest from "./LaboratoryTest";
import LaboratorySales from "./LaboratorySales";
import LaboratoryPatientPending from "./LaboratoryPatientPending";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faDatabase,
  faHandHoldingUsd,
  faUserInjured,
  faVials,
} from "@fortawesome/free-solid-svg-icons";
import LaboratoryInventoryList from "./LaboratoryInventoryList";

const HIMSLaboratoryMonitor = () => {
  const [category, setCategory] = React.useState(0);

  const handleChange = (event, newCategory) => {
    event.persist();
    setCategory(newCategory);
  };

  return (
    <Fragment>
      <Container
        breadcrumbs={{
          enable: true,
          current: "laboratory monitoring",
          items: [{ name: "Dashboard", path: "/sph/app" }],
        }}
        title="Laboratory Monitoring"
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box component={Paper} variant="outlined" mb={2}>
              <Tabs
                value={category}
                onChange={handleChange}
                indicatorColor="primary"
                textColor="primary"
                variant="scrollable"
                scrollButtons="on"
              >
                <Tab
                  wrapped
                  label="Lab Test"
                  icon={<FontAwesomeIcon icon={faVials} size={"2x"} />}
                />
                <Tab
                  wrapped
                  label="Lab Inventory"
                  icon={<FontAwesomeIcon icon={faDatabase} size={"2x"} />}
                />
                <Tab
                  wrapped
                  label="Sales"
                  icon={<FontAwesomeIcon icon={faHandHoldingUsd} size={"2x"} />}
                />
                <Tab
                  wrapped
                  label="Patients Pending"
                  icon={<FontAwesomeIcon icon={faUserInjured} size={"2x"} />}
                />
              </Tabs>
            </Box>

            <TabPanel value={category} index={0}>
              <LaboratoryTest />
            </TabPanel>

            <TabPanel value={category} index={1}>
              <LaboratoryInventoryList />
            </TabPanel>

            <TabPanel value={category} index={2}>
              <LaboratorySales />
            </TabPanel>

            <TabPanel value={category} index={3}>
              <LaboratoryPatientPending />
            </TabPanel>
          </Grid>
        </Grid>
      </Container>
    </Fragment>
  );
};

export default HIMSLaboratoryMonitor;
